import addProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/AddProductFilters";
import removeProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/RemoveProductFilters";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import { FacetModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { productListCategoryFiltersStyles } from "@insite/content-library/Widgets/ProductList/ProductListCategoryFilters";
import  { ProductListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { TYPOGRAPHY } from "@tCentro/theme/design";
import NISProductListFiltersAccordionSection from "@tCentro/Widgets/ProductList/NISProductListFilterAccordionSection";
import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    expandByDefault = "expandByDefault",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.expandByDefault]: boolean;
    };
}
export interface ProductListAttributeFiltersStyles {
    showMoreLessLinkStyle?: InjectableCss;
}

const mapStateToProps = (state: CustomApplicationState) => {
    const attributeFilteredData = state.t_components?.attributeNames?.mainData;
    return {
        attributeTypeFacets: getProductListDataViewProperty(state, "attributeTypeFacets"),
        attributeFilteredData,
        session: state.context.session,
        isSearchPage: state.pages.productList.isSearchPage,
    };
};

const mapDispatchToProps = {
    addProductFilters,
    removeProductFilters,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export const productListFilterAccordionSectionStyles: ProductListFilterAccordionSectionStyles = {};

export const productListAttributeFiltersStyles: ProductListAttributeFiltersStyles = {
    showMoreLessLinkStyle: {
        css: css`
            font-family: ${TYPOGRAPHY.fontFamily.base};
            font-size: ${TYPOGRAPHY.size.large};
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: #0F96D9;
            margin-top:24px;
            margin-left: 15px;
        `,
    },
};

const styles = productListAttributeFiltersStyles;
const ProductListAttributeFilters: FC<Props> = ({
    attributeTypeFacets,
    addProductFilters,
    removeProductFilters,
    fields,
    attributeFilteredData,
    session,
    isSearchPage,
}) => {
    const [expanded, setExpanded] = useState(false);

    // TODO ISC-11787 - make showMoreLimit configurable
    const showMoreLimit = 10;
    const isLoggedIn = (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const showMoreAttribute = isLoggedIn ? isSearchPage ? 6 : 7  : isSearchPage ? 7 : 8;
  
    if (!attributeTypeFacets?.length) {
        return null;
    }

    if(attributeFilteredData.length===0){
       return null
    }

    const mainFacetData = attributeFilteredData.length
        ? attributeTypeFacets.filter(item => attributeFilteredData.includes(item.name))
        : attributeTypeFacets;
    const limitedAttribute = expanded ? mainFacetData : mainFacetData?.slice(0, showMoreAttribute);

   
    const onChangeFacet = (facet: FacetModel) => {
        if (facet.selected) {
            removeProductFilters({ attributeValueIds: [facet.id] });
        } else {
            addProductFilters({ attributeValueIds: [facet.id] });
        }
    };

    return (
        <>
            {limitedAttribute.map(a =>
                a.attributeValueFacets ? (
                    <NISProductListFiltersAccordionSection
                        key={a.attributeTypeId}
                        title={a.nameDisplay}
                        facets={a.attributeValueFacets.map<FacetModel>(av => ({
                            ...av,
                            id: av.attributeValueId,
                            name: av.valueDisplay,
                        }))}
                        onChangeFacet={onChangeFacet}
                        showMoreLimit={showMoreLimit}
                        expandByDefault={fields.expandByDefault}
                        extendedStyles={productListCategoryFiltersStyles}
                    />
                ) : null,
            )}
            {mainFacetData &&
                mainFacetData.length > showMoreLimit  && 
                (expanded ? (
                    <Link onClick={() => setExpanded(false)} {...styles.showMoreLessLinkStyle}>
                        {translate("Show Less Filters")}
                    </Link>
                ) : (
                    <Link onClick={() => setExpanded(true)} {...styles.showMoreLessLinkStyle}>{translate("Show More Filters")}</Link>
                ))}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListAttributeFilters),
    definition: {
        group: "Product List",
        displayName: "NIS Attribute Filters",
        allowedContexts: ["ProductListPage"],
        fieldDefinitions: [
            {
                name: fields.expandByDefault,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
